export default "https://statics.cloudfastin.top/static/v1.27.31/store/images/track.png?28cda1cd25e9f1ba2dcf183f3a6de84b";